import React, { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Outlet } from 'react-router-dom'

import { Box, CircularProgress } from '@mui/material'

const LoadingSpinner = (props: { active: boolean }) => {
  const { active } = props

  const style = {
    display: 'inline-block',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    background: 'rgba(225, 225, 225, 0.3)',
    height: '100%',
    zIndex: '9999',
    textAlign: 'center'
  }

  const spinnerStyle = {
    margin: 'auto',
    width: '20px',
    height: '20px',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }

  return active ? (
    <Box sx={style}>
      <CircularProgress sx={spinnerStyle} />
    </Box>
  ) : (
    <React.Fragment />
  )
}

const Loading: React.FC = () => {
  return <LoadingSpinner active />
}

export const RequiredAuth: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth()

  useEffect(() => {
    if (!authState) {
      return
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin
      )
      oktaAuth.setOriginalUri(originalUri)
      oktaAuth.signInWithRedirect()
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated])

  if (!authState || !authState?.isAuthenticated) {
    return <Loading />
  }

  return <Outlet />
}
